import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaPinterest,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer style={{
      // backgroundColor: '#2e3136ff',
      backgroundColor: '#25303e',
      color: '#d6d3d3ff',
      fontFamily: 'Montserrat, sans-serif',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    }}>

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '2rem',
        padding: '3rem 1rem'
      }}>
        {/* Column 1: Brand + Contact + Social */}
        <div style={{ flex: '1 1 260px', minWidth: '250px' }}>
          <h4 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            fontFamily: 'Figtree',
            color: '#d6d3d3ff',
            marginBottom: '1rem'
          }}>
            Osmossion
          </h4>
          <p style={{ fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1.5rem', fontFamily: 'Figtree' }}>
            Dedicated to better kidney health with safe, reliable, and compassionate dialysis care.
          </p>

          {/* Contact Info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaWhatsapp style={{ color: '#29683eff', fontSize: '20' }} />
              <a href="https://wa.me/919101038129" target="_blank" rel="noreferrer" style={{ color: '#d6d3d3ff', textDecoration: 'none', fontFamily: 'Figtree', }}>
                +91 91010 38129
              </a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaPhoneAlt style={{ color: '#007c9d' }} />
              <a href="tel:+918437048180" style={{ color: '#d6d3d3ff', fontFamily: 'Figtree', textDecoration: 'none' }}>
                +91 84370 48180
              </a>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaEnvelope style={{ color: '#007c9d' }} />
              <a href="mailto:osmossion@gmail.com" style={{ color: '#d6d3d3ff', fontFamily: 'Figtree', textDecoration: 'none' }}>
                osmossion@gmail.com
              </a>
            </div>
          </div>

          {/* Social Icons */}
          <div style={{
            display: 'flex',
            gap: '1rem',
            marginTop: '1.5rem',
            fontSize: '1.3rem'
          }}>
            <a href="#!"><FaFacebookF style={{ color: '#007c9d' }} /></a>
            <a href="#!"><FaInstagram style={{ color: '#007c9d' }} /></a>
            <a href="#!"><FaTwitter style={{ color: '#007c9d' }} /></a>
            <a href="#!"><FaYoutube style={{ color: '#007c9d' }} /></a>
            <a href="#!"><FaPinterest style={{ color: '#007c9d' }} /></a>
          </div>
        </div>

        {/* SHOP Links */}
        <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
          <h4 style={{ fontFamily: 'Figtree', fontSize: '1.4rem', color: '#d6d3d3ff', marginBottom: '1rem' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', padding: 0, fontSize: '1rem', lineHeight: '2.5', fontFamily: 'Figtree' }}>
            {['Kidney Health', 'Patient Care', 'About Us','Dialysis Services'].map(item => (
              <li key={item}>
                <a
                  href="#!"
                  style={{
                    color: '#d6d3d3ff',
                    fontSize: 15.4,
                    textDecoration: 'none',
                    fontFamily: 'Figtree, sans-serif'
                  }}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>

        </div>

        {/* HELP Links */}
        <div style={{ flex: '1 1 150px', minWidth: '150px' }}>
          <h4 style={{ fontFamily: 'Figtree', fontSize: '1.4rem', color: '#d6d3d3ff', marginBottom: '1rem' }}>Help</h4>
          <ul style={{ listStyle: 'none', padding: 0, fontSize: '1rem', lineHeight: '2.5', fontFamily: 'Figtree' }}>
            <li>
              <a href="/contact" style={{ color: '#d6d3d3ff', textDecoration: 'none' }}>Contact Us</a>
            </li>
            <li>
              <a href="/faqs" style={{ color: '#d6d3d3ff', textDecoration: 'none' }}>FAQs</a>
            </li>
            <li>
              <a href="/appointments" style={{ color: '#d6d3d3ff', textDecoration: 'none' }}>Book Appointment</a>
            </li>
            <li>
              <a href="/privacy-policy" style={{ color: '#d6d3d3ff', textDecoration: 'none' }}>Privacy Policy</a>
            </li>
          </ul>
        </div>


        {/* Newsletter */}
        <div style={{ flex: '1 1 240px', minWidth: '250px' }}>
          <h4 style={{ fontFamily: 'Figtree', fontSize: '1.4rem', color: '#d6d3d3ff', marginBottom: '1rem' }}>Stay Updated</h4>
          <p style={{ fontSize: '0.9rem', marginBottom: '1rem', fontFamily: 'Figtree' }}>
            Subscribe to our newsletter for exclusive offers and product updates.
          </p>
          <input
            type="email"
            placeholder="you@example.com"
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ccc',
              borderRadius: '12px',
              outline: 'none',
              color: '#121212',
              marginBottom: '0.8rem',
              fontWeight: 'bold',
              fontFamily: 'Figtree',
            }}
          />
          <button style={{
            background: 'rgba(219, 76, 51, 1)',
            color: '#fff',
            padding: '10px 18px',
            border: 'none',
            borderRadius: '12px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: '100%',
          }}>
            Subscribe
          </button>
        </div>
      </div>

      {/* Footer Bottom */}
      <div style={{
        textAlign: 'center',
        padding: '1.5rem 0',
        fontSize: '0.85rem',
        borderTop: '1px solid #3a3d42ff',
        fontFamily: 'Figtree',
        color: '#a8a3a3ff',
      }}>
        © {new Date().getFullYear()} Osmossion | All rights reserved.
      </div>
    </footer >
  );
};

export default Footer;
